/** Company / legal identity for Terms, Privacy Policy, and DPA (build-time env). */

const FALLBACK = {
  legalName: "FractoLabs Pty Ltd",
  brandName: "FractoLabs",
  address: "8 Springdale St, Claremont Meadows, Wollongong, NSW, Australia, 2500",
  supportEmail: "support@fractolabs.com",
  governingLaw: "New South Wales, Australia",
};

/** Empty / unset / whitespace-only env → ""; otherwise trimmed value. */
export function optionalEnv(value) {
  if (typeof value !== "string") {
    return "";
  }
  return value.trim();
}

/** Parenthetical ACN/ABN clause for inline legal copy, or "" when both are empty. */
export function formatCompanyRegistrationClause(company) {
  const parts = [];
  if (company?.acn) {
    parts.push(`ACN: ${company.acn}`);
  }
  if (company?.abn) {
    parts.push(`ABN: ${company.abn}`);
  }
  return parts.length ? ` (${parts.join("; ")})` : "";
}

export const LEGAL_COMPANY = {
  legalName: process.env.REACT_APP_COMPANY_LEGAL_NAME || FALLBACK.legalName,
  brandName: process.env.REACT_APP_COMPANY_BRAND_NAME || FALLBACK.brandName,
  acn: optionalEnv(process.env.REACT_APP_COMPANY_ACN),
  abn: optionalEnv(process.env.REACT_APP_COMPANY_ABN),
  address: process.env.REACT_APP_COMPANY_ADDRESS || FALLBACK.address,
  supportEmail: process.env.REACT_APP_SUPPORT_EMAIL || FALLBACK.supportEmail,
  governingLaw: process.env.REACT_APP_GOVERNING_LAW || FALLBACK.governingLaw,
};
